const endpoints = [
    '/places',
    '/devices',
    'auth/register',
    '/auth/verification/verify',
    '/auth/forgot-password',
    '/auth/reset-password/check'
];

export default endpoints;